import _ from "lodash-es";
import Cookie from "@/lib/common/cookie";
import Constraint from "@/lib/common/constraint";
import TimeUtil from "@/lib/common/time-util";
import Url from "@/lib/common/url";
import User from "@/lib/model/user/user";
import Company from "@/lib/model/company/company";
import vuexStore from "@/store/vuex-store";
import Store from "@/lib/common/Store";
import AccountInfo from "@/lib/model/account/info";

export default class Auth {
  static initUserLock = false;
  static infoLock = false;
  static initCompanyLock = false;
  static initCompaniesLock = false;

  static get token(): string {
    return Cookie.get(Constraint.tokenKey);
  }

  static set token(value: string) {
    Cookie.set(Constraint.tokenKey, value, 365 * 5);
  }

  static get userId(): string {
    return Cookie.get(Constraint.userIdKey);
  }

  static set userId(value: string) {
    Cookie.set(Constraint.userIdKey, value, 365 * 5);
  }

  static set currentPageSize(value: string) {
    Cookie.set(Constraint.currentPageSize, value, 365 * 5);
  }

  static get currentPageSize(): string {
    return Cookie.get(Constraint.currentPageSize);
  }

  static get companyList(): Company[] {
    const companyList = Cookie.get(Constraint.companyListKey);
    try {
      if (companyList) {
        return JSON.parse(decodeURIComponent(companyList));
      } else {
        return [];
      }
    } catch (error) {
      return [];
    }
  }

  static set companyList(companyList: Company[]) {
    Cookie.set(Constraint.companyListKey, JSON.stringify(companyList), 365 * 5);
  }

  // 旧逻辑 沿用的老系统 每次调用公司id  都会把当前url里的公司id覆盖到cookie里的公司id 再返回它
  static get companyId(): string {
    let queryCompanyId = Url.query("companyId");
    const cookieCompanyId = Cookie.get(Constraint.companyIdKey);
    if (_.isEmpty(queryCompanyId) && !_.isEmpty(cookieCompanyId)) {
      queryCompanyId = cookieCompanyId;
      Url.setQuery("companyId", cookieCompanyId); //历史遗留：get里面塞了个set.... 改完companyid 还导致会去replace当前路由
    } else if (!_.isEmpty(queryCompanyId)) {
      Auth.companyId = queryCompanyId;
    }
    return queryCompanyId;
  }
  //新逻辑  返回公司id 取值优先级 : url > cookie ,  只取值， 互不覆盖
  // static get companyId(): string {
  //   let queryCompanyId = Url.query("companyId");
  //   const cookieCompanyId = Cookie.get(Constraint.companyIdKey);
  //   if (_.isEmpty(queryCompanyId) && !_.isEmpty(cookieCompanyId)) {
  //     queryCompanyId = cookieCompanyId;
  //   }
  //   return queryCompanyId ?? "";
  // }

  static set companyId(id: string) {
    Url.setQuery("companyId", id);
    Cookie.set(Constraint.companyIdKey, id, 365 * 5);
    localStorage.setItem("hina-companyId", id);
  }

  static logout() {
    this.token = "";
    this.companyId = "";
    this.userId = "";
    this.currentPageSize = "";
    Cookie.del(Constraint.tokenKey);
    Cookie.del(Constraint.companyIdKey);
    Cookie.del(Constraint.companyListKey);
    Cookie.del(Constraint.userIdKey);
    Cookie.del(Constraint.currentPageSize);
    Store.getAccountStoreModule().then(module => {
      module.updateAccountInfo(new AccountInfo());
    });
    //除了是否新手引导已阅外 都删
    // const showNewTip = JSON.parse(localStorage.getItem("showNewTip") || "0");
    // localStorage.clear();
    // localStorage.setItem("showNewTip", JSON.stringify(showNewTip));
  }

  static changeCom(id: string) {
    Cookie.set(Constraint.companyIdKey, id, 365 * 5);
  }

  static initUser(autoResolve = true): Promise<User> {
    if (this.initUserLock) {
      return TimeUtil.sleep(500).then(() => {
        return this.initUser(autoResolve);
      });
    }
    if (_.isEmpty(vuexStore.user.id)) {
      if (Auth.token.length < 10) {
        return Promise.reject();
      } else {
        this.initUserLock = true;
        return User.info(autoResolve).finally(() => {
          this.initUserLock = false;
        });
      }
    } else {
      return Promise.resolve(vuexStore.user);
    }
  }
  //获取当前公司信息
  static initCompany(autoResolve = true): Promise<Company> {
    if (this.initCompanyLock) {
      return TimeUtil.sleep(500).then(() => {
        return this.initCompany(autoResolve);
      });
    }
    // if (!_.isEmpty(vuexStore.company.id)) {
    //   return Promise.resolve(vuexStore.company);
    // }
    if (_.isEmpty(Auth.companyId)) {
      return Promise.reject(new Error("公司信息不正确"));
    }
    this.initCompanyLock = true;
    return Company.info(Auth.companyId, autoResolve).finally(() => {
      this.initCompanyLock = false;
    });
  }
  //获取公司列表 登录后默认第一个
  static initCompanies(autoResolve = true): Promise<Company[]> {
    if (this.initCompaniesLock) {
      return TimeUtil.sleep(500).then(() => {
        return this.initCompanies(autoResolve);
      });
    }
    if (vuexStore.companies.length > 0) {
      return Promise.resolve(vuexStore.companies);
    }
    this.initCompaniesLock = true;
    return Company.list(autoResolve)
      .then(companies => {
        if (companies.length > 0) {
          if (_.isEmpty(_.keyBy(companies, "id")[Auth.companyId])) {
            Auth.companyId = companies[0].id;
          }
        } else {
          Auth.companyId = "";
        }
        return companies;
      })
      .finally(() => {
        this.initCompaniesLock = false;
      });
  }

  static async init(autoResolve = true): Promise<Company> {
    await this.initUser(autoResolve);
    await this.initCompanies(autoResolve);
    return this.initCompany(autoResolve);
    // return this.initUser(autoResolve)
    //   .then(() => {
    //     return this.initCompanies(autoResolve);
    //   })
    //   .then(() => {
    //     return this.initCompany(autoResolve);
    //   });
  }
}
